import { render, staticRenderFns } from "./changeScore.vue?vue&type=template&id=61c2a098&scoped=true&"
import script from "./changeScore.vue?vue&type=script&lang=js&"
export * from "./changeScore.vue?vue&type=script&lang=js&"
import style0 from "./changeScore.vue?vue&type=style&index=0&id=61c2a098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2a098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c2a098')) {
      api.createRecord('61c2a098', component.options)
    } else {
      api.reload('61c2a098', component.options)
    }
    module.hot.accept("./changeScore.vue?vue&type=template&id=61c2a098&scoped=true&", function () {
      api.rerender('61c2a098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/changeScore.vue"
export default component.exports